var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({staticClass:"text-capitalize",attrs:{"dense":"","outlined":"","auto-grow":"","label":_vm.$t(_vm.label),"value":_vm.value,"rules":_vm.rules}},'v-textarea',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }